import { useState } from 'react'
import { useQuery } from 'react-query'

import { Buttons } from '@/components/common/buttons'
import { UpdatedAtLabel } from '@/components/common/data-display/updated-label-v2'
import { PageHeader } from '@/components/common/navigation/PageHeader'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Sheet, SheetTrigger } from '@/components/ui/sheet'
import { Chamados } from '@/features/chamados/components'
import { ChamadoService } from '@/features/chamados/services/chamado.service'
import { Asset_Displayer } from '@/features/patrimonios/components/asset-displayer'
import { AssetService } from '@/features/patrimonios/services/asset.service'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'

const Component = () => {
  const { client } = useAuthStore()
  const [isOpen, setIsOpen] = useState(false)

  const {
    data: calls,
    isFetching,
    dataUpdatedAt,
    refetch,
  } = useQuery(['dashboard-page-external', { client }], async () => {
    if (client)
      return await ChamadoService.search({
        assetNumber: client.asset.assetNumber,
        contractId: client.contract.id,
      })
  })

  const { data: asset } = useQuery(
    ['dashboard-page-external-asset', { client }],
    async () => {
      if (client)
        return await AssetService.findById({ id: client.asset.id })
    },
  )

  return (
    <>
      <PageHeader title="Bem-vindo" />

      <div className="p-8">
        {asset && <Asset_Displayer data={asset} />}

        <Accordion
          type="single"
          defaultValue="chamados"
          collapsible
          className="mt-8"
        >
          <AccordionItem value="chamados">
            <AccordionTrigger>Chamados</AccordionTrigger>

            <AccordionContent>
              <div className="mb-4">
                <div className="flex w-fit items-center gap-2">
                  <Sheet open={isOpen} onOpenChange={setIsOpen}>
                    <SheetTrigger asChild>
                      <Buttons.Add />
                    </SheetTrigger>
                    <Chamados.Core.Adicionar_Dialog_External
                      onSuccess={() => refetch()}
                      onClose={() => setIsOpen(false)}
                    />
                  </Sheet>

                  <Buttons.Refresh
                    isLoading={isFetching}
                    onClick={() => refetch()}
                  />
                </div>

                <UpdatedAtLabel updatedAt={dataUpdatedAt} />
              </div>

              {calls && (
                <Chamados.Core.Kanban_Card data={calls} isExternal={true} />
              )}
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </>
  )
}

export default Component
